module.exports = __webpack_public_path__ + "img/newapp.9c2cccf1.svg";